<template>
    <vx-card :title='$t("TimesPerMonth")' collapse-action>
        <div class="mt-6">
            <vs-table :data="times">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <div class="flex flex-wrap-reverse items-center mb-3">
                        <vs-button type="border" color="success" icon-pack="feather" icon="icon-refresh-cw" @click="regenerateTimes">{{$t("RegenerateTimes")}}</vs-button>
                    </div>

                </div>

                <template slot="thead">
                    <vs-th>{{$t("Year")}}</vs-th>
                    <vs-th>{{$t("Month")}}</vs-th>
                    <vs-th>{{$t("WorkDays")}}</vs-th>
                    <vs-th>{{$t("Holidays")}}</vs-th>
                    <vs-th>{{$t("Time")}}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

                        <vs-td :data="data[indextr].year">
                            {{data[indextr].year}}
                        </vs-td>

                        <vs-td :data="data[indextr].month">
                            {{data[indextr].month}}
                        </vs-td>

                        <vs-td :data="data[indextr].work_days">
                            {{data[indextr].work_days}}
                        </vs-td>

                        <vs-td :data="data[indextr].holidays">
                            {{data[indextr].holidays}}
                        </vs-td>

                        <vs-td :data="data[indextr].time">
                            {{data[indextr].time}}
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </div>

    </vx-card>
</template>
<script>

    export default {
        props: {
            typeId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {

                times: [],

            }
        },
        methods: {
            updateTimes() {
                const thisIns = this;
                this.$http.get('/api/v1/user_type/' + this.typeId + '/times')
                    .then(function (response) {
                        thisIns.times = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            regenerateTimes() {

                const thisIns = this;
                this.$http.get('/api/v1/user_type/' + this.typeId + '/times/regenerate')
                    .then(function () {
                        thisIns.updateTimes();
                        thisIns.$vs.notify({
                            title:'Success',
                            position:'top-right',
                            text: thisIns.$t("TimesRegenerated"),
                            color:'success',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
        },
        created() {
            this.updateTimes();
        },
    }

</script>
